import { Calendar, Film, Sparkles, Users } from 'lucide-react';
import { LandingTemplate, type LandingData } from '../components/LandingTemplate';
import { LANDING_GUIDES } from '../lib/landingGuides';

const data: LandingData = {
  seo: {
    title: 'Cómo programar publicaciones en Facebook · Zettapost',
    description:
      'Cómo programar publicaciones en tu página de Facebook desde Meta Business Suite y con Zettapost, junto a tus otras redes. Prueba 3 días gratis.',
    canonical: 'https://zettapost.com/programar-facebook',
  },
  hero: {
    eyebrow: 'Programar Facebook',
    headlinePre: 'Programa Facebook',
    headlineAccent: 'sin abrir Meta Business Suite.',
    subhead:
      'Publica posts, Reels y Stories en tus Páginas de Facebook a la hora que tú decidas, gestiona varios negocios desde el mismo sitio y olvídate del laberinto del Business Manager.',
    bullets: [
      'Posts, Reels y Stories',
      'Varias páginas a la vez',
      'API oficial de Meta',
      '3 días gratis',
    ],
  },
  why: {
    eyebrow: '¿Por qué Zettapost para Facebook?',
    title: 'Programar Facebook sin abrir 5 pestañas.',
    subtitle:
      'Pensado para community managers, negocios locales y agencias que gestionan Facebook (a veces a su pesar) y quieren tardar 5 minutos en vez de 50.',
    items: [
      {
        Icon: Calendar,
        title: 'Programa cuándo quieras',
        description:
          'Programa hora exacta o usa la cola semanal. Zettapost publica solo, también de noche y los fines de semana, sin tener que estar pendiente.',
      },
      {
        Icon: Film,
        title: 'Posts, Reels y Stories',
        description:
          'Soportamos los tres formatos nativos de Facebook con la API oficial de Meta: feed posts con imagen, vídeo o enlace, Reels verticales y Stories.',
      },
      {
        Icon: Users,
        title: 'Varias páginas a la vez',
        description:
          'Conecta tantas páginas como necesites y agrúpalas por marca. Ideal para agencias y franquicias que llevan varios negocios.',
      },
      {
        Icon: Sparkles,
        title: 'IA que escribe el copy',
        description:
          'Sube la imagen o el vídeo y la IA te genera el texto adaptado al tono de cada marca. Tú revisas, ajustas y programas.',
      },
    ],
  },
  guide: LANDING_GUIDES.facebook,
  faqs: [
    {
      q: '¿Necesito tener una Página de Facebook o vale con perfil personal?',
      a: 'Necesitas una Página de Facebook (Page). La API oficial de Meta no permite programar en perfiles personales — esto es una limitación de la propia red social, no nuestra. Crear una Página es gratis y se hace en 1 minuto.',
    },
    {
      q: '¿Puedo programar Reels en Facebook?',
      a: 'Sí. Subes el vídeo vertical 9:16, eliges la portada y la hora de publicación y Zettapost se encarga del resto, sin notificaciones al móvil ni "trucos".',
    },
    {
      q: '¿Y Stories de Facebook?',
      a: 'Sí. Soportamos imagen y vídeo vertical 9:16 para Stories de Facebook. Los stickers interactivos avanzados se añaden desde el móvil, lo demás se programa desde Zettapost.',
    },
    {
      q: '¿Puedo gestionar varias páginas?',
      a: 'Sí. Conectas todas las Páginas que administres y las agrupas por marca. Cada marca tiene su tono de voz y su paleta de colores propios. Ideal para agencias multi-cliente.',
    },
    {
      q: '¿Soporta enlaces con preview (link preview)?',
      a: 'Sí. Pegas el enlace, Facebook genera el preview automáticamente y tú añades el copy. Se publica con la tarjeta de enlace nativa de Facebook.',
    },
    {
      q: '¿Funciona también con Instagram al mismo tiempo?',
      a: 'Sí. Conectas Instagram en paralelo y desde el mismo editor decides en qué redes publicar el contenido (un post puede ir a Facebook + Instagram a la vez, adaptando el copy a cada una).',
    },
  ],
  finalCta: {
    title: 'Programa Facebook',
    titleAccent: 'sin perder la cabeza.',
    description: 'Crea tu cuenta y conecta tus páginas gratis durante 3 días.',
  },
  related: [
    { to: '/programar-instagram', label: 'Programar Instagram' },
    { to: '/programar-tiktok', label: 'Programar TikTok' },
    { to: '/precios', label: 'Ver precios' },
    { to: '/blog', label: 'Blog' },
  ],
};

export function ProgramarFacebook() {
  return <LandingTemplate data={data} />;
}
